// ProductDetails.tsx
import React from "react";
import { useParams } from "react-router-dom";
import ProductHero from "./ProductSections/ProductHero";
import ProductSections from "./ProductSections/ProductSections";
import { products, Product } from "../data/products";
import Footer from "../components/Footer";

const ProductDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const product: Product | undefined = products.find(
    (p) => p.id === Number(id)
  );

  if (!product) {
    return <div className="not-found">Product not found</div>;
  }

  return (
    <div>
      <section>
        <ProductHero product={product} />
      </section>

      <section>
        <ProductSections product={product} />
      </section>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default ProductDetails;
